import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Card, CardContent, Chip, Collapse, IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ActivityType } from '../../redux/reducers/activityReducer';
import { selectNameList } from '../../redux/reducers/organizationReducer';
import formatDate from '../../utils/dateHelpers';

export default function Activity({ activity }) {
  const { t } = useTranslation();
  const owners = useSelector((state) => selectNameList(state, activity.activityOwner));
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card sx={{ px: 2, py: 1 }}>
      <CardContent variant="controlDetailsContent">
        <Stack direction="row" justifyContent="space-between">
          <Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="activityTitle">{activity.title}</Typography>
              <Chip
                size="small"
                color="controlChip"
                label={t(`activity.status.${activity.activityStatus}`)}
              />
            </Stack>
            <Typography>
              {`${owners} - ${t('activity.modal.deadline')} ${formatDate(activity.deadline)}`}
            </Typography>
          </Stack>
          <IconButton onClick={handleExpandClick}>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</IconButton>
        </Stack>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Stack spacing={2} sx={{ mt: '16px' }}>
            <Stack>
              <Typography>{t('activity.modal.description')}</Typography>
              <Typography variant="body2">{activity.description}</Typography>
            </Stack>
            <Stack>
              <Typography>{t('activity.modal.activityOwner')}</Typography>
              <Typography variant="body2">{owners}</Typography>
            </Stack>
            <Stack>
              <Typography>{t('activity.modal.type')}</Typography>
              <Typography variant="body2">{t(`activity.type.${activity.activityType}`)}</Typography>
            </Stack>
            {activity.activityType === ActivityType.RECURRING_OPERATIONAL_ACTIVITY && (
              <Stack>
                <Typography>{t('activity.modal.repeatsEvery')}</Typography>
                <Typography variant="body2">{t(`activity.interval.${activity.repeatEvery}`)}</Typography>
              </Stack>
            )}
            <Stack>
              <Typography>
                {`${t('activity.modal.deadline')} ${formatDate(activity.deadline)}`}
              </Typography>
            </Stack>
          </Stack>
        </Collapse>
      </CardContent>
    </Card>
  );
}
